import { createContext as t } from "react";
const r = t({
  accessibilityLayer: !0,
  formatter: () => "",
  itemSorter: () => "",
  labelFormatter: () => ""
});
export {
  r as TooltipContext
};
